import { useQuery } from '@tanstack/react-query';
import { caixaApi } from '../api/caixa.js';
import { useSessao } from '../auth/SessaoContext.jsx';

/**
 * "Há caixa aberto?", para os modais que recebem dinheiro e avisam quando não
 * há. `undefined` é "não sei" — carregando, falhou, ou o perfil não pode ver
 * o caixa — e quem usa não avisa nesse caso: não se adivinha. A permissão
 * aqui é cosmética; o servidor é quem recusa a leitura.
 */
export function useCaixaAberto(): boolean | undefined {
  const { pode } = useSessao();
  const consulta = useQuery({
    queryKey: ['caixa', 'atual'],
    queryFn: caixaApi.atual,
    staleTime: 30_000,
    enabled: pode('financeiro', 'ler'),
  });
  return consulta.data ? consulta.data.caixa !== null : undefined;
}
